
var url = window.location.href;
url = url.split('.html')[0];
//url = url.substring(0, url.lastIndexOf("."));
window.history.replaceState( null, null, url );

document.addEventListener('DOMContentLoaded', () => {
  // Fade in elements when scrolled to
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target); // Stop observing once faded in
    }
  });
}, { threshold: 0.1}); // Trigger when 10% of the element is visible

document.querySelectorAll('.fade-in-element').forEach(el => observer.observe(el));
});
// Mobile Menu

const hamburger = document.querySelector(".js-hamburger");
const closeMenu = document.querySelector(".js-close");
const menu = document.querySelector(".js-mobile-menu");
const mainBody = document.querySelector(".js-main-body");
const html = document.querySelector(".html");
const heroClickBack = document.querySelector(".hero");
const sectionClickBack = document.querySelector(".section");

hamburger.addEventListener("click", function () {
  menu.classList.add("mobile-nav--active");
  mainBody.classList.add("main-body--active");
  html.classList.add("html--active");

});

closeMenu.addEventListener("click", function () {
  menu.classList.remove("mobile-nav--active");
  mainBody.classList.remove("main-body--active");
  html.classList.remove("html--active");

});




// Get the button:
let mybutton = document.getElementById("btt");

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () { scrollFunction() };

function scrollFunction() {
  if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
    // mybutton.style.display = "block";
    mybutton.classList.remove("btt--inactive");
    mybutton.classList.add("btt--active");
  } else {
    // mybutton.style.display = "none";
    mybutton.classList.remove("btt--active");
    mybutton.classList.add("btt--inactive");


  }
}

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

// Search Input Expand

// const searchBtn = document.querySelector(".js-search-btn");
// const searchInput = document.querySelector(".js-search-input");

// searchBtn.addEventListener("click", function () {
//   searchBtn.parentElement.classList.toggle("main-nav__link--search--active");
//   searchInput.focus()
// });

// searchInput.addEventListener("blur", function () {
//   searchBtn.parentElement.classList.remove("main-nav__link--search--active");
// });

// FORM JS
var form = $('.js-contact-form'),
  message = $('.contact-success'),
  form_data;

// Success function
function done_func(response) {
  message.fadeIn()
  message.html(response);
  setTimeout(function () {
    message.fadeOut();
  }, 10000);
  form.find('input:not([type="submit"]), textarea').val('');
}

// fail function
function fail_func(data) {
  message.fadeIn()
  message.html(data.responseText);
  setTimeout(function () {
    message.fadeOut();
  }, 10000);
}

form.submit(function (e) {
  e.preventDefault();
  form_data = $(this).serialize();
  $.ajax({
    type: 'POST',
    url: form.attr('action'),
    data: form_data
  })
    .done(done_func)
    .fail(fail_func);
});

var expanded = false;

function showCheckboxes() {
  var checkboxes = document.getElementById("checkboxes");
  if (!expanded) {
    checkboxes.style.display = "block";
    expanded = true;
  } else {
    checkboxes.style.display = "none";
    expanded = false;
  }
}

window.addEventListener("load", function () {
  const selected = [];
  const colorsSelected = document.querySelector(".altSelect");
  for (let opts of document.querySelectorAll('[name="colors[]"]')) {
    opts.addEventListener("click", function () {
      let index = selected.indexOf(opts.value);
      let selection = ["none"];
      if (index !== -1) {
        selected.splice(selected.indexOf(opts.value), 1);
      } else {
        selected.splice(1, 0, opts.value);
      }
      console.log(selected);
      if (selected.length > 0) selection = selected;
      colorsSelected.setAttribute("data-multiselect", selection.toString());
    });
  }
});

// LIGHT and DARK mode toggle



let lightModeBtn = document.querySelectorAll(".js-lightmode");
let lightModeIcon = document.querySelectorAll(".js-search-btn");
let themeBody = document.querySelector(".js-main-body");
let mobileMenu = document.querySelector(".js-mobile-menu");

lightModeBtn.forEach((btn) => {
  // if(themeBody.classList.contains(""))
  btn.addEventListener("click", function () {
    themeBody.classList.toggle("dark");

    lightModeIcon.forEach((icon) => {

      if (themeBody.classList.contains('dark')) {
        localStorage.setItem('darkMode', 'enabled');
        document.body.classList.add("darkMode");
        mobileMenu.classList.add("mobile-nav--dark");
        icon.classList.add("js-lightmode--active");

      } else {
        localStorage.setItem('darkMode', 'disabled');
        document.body.classList.remove("darkMode");
        mobileMenu.classList.remove("mobile-nav--dark");
        icon.classList.remove("js-lightmode--active");


      }
    });

  })
});

function applyThemePreference() {
  const isDarkModeEnabled = localStorage.getItem('darkMode') === 'enabled';
  if (isDarkModeEnabled) {
    themeBody.classList.add('dark');
    document.body.classList.add("darkMode");
    mobileMenu.classList.add("mobile-nav--dark");

  }
}

applyThemePreference();

// // Apply light mode or dark mode depending on time of day
// function setTimeBasedTheme() {
//   const currentHour = new Date().getHours();
//   // Define the time range for dark mode (e.g., from 6 PM to 6 AM)
//   const isNightTime = (currentHour >= 18 || currentHour < 6);
//   const bodyElement = document.querySelector(".js-main-body");

//   if (isNightTime) {
//     bodyElement.classList.add('dark');
//   } else {
//     bodyElement.classList.remove('dark');
//   }
// }

// // Run the function when the page loads
// window.addEventListener('load', setTimeBasedTheme);

// // Optional: Update the theme periodically if the user stays on the page past the threshold
// setInterval(setTimeBasedTheme, 1000 * 60 * 15); // Check every 15 minutes


// accordion
const accordions = document.querySelectorAll(".accordion__qa");

for (let accordion of accordions) {
  accordion.addEventListener("click", function () {
    // check if the accordion already has the class
    if (this.classList.contains("accordion__qa--active")) {
      this.classList.remove("accordion__qa--active");
    } else {
      for (let el of accordions) {
        // el.classList.remove("accordion__qa--active");
      }
      this.classList.toggle("accordion__qa--active");
    }
  });
}

// New Form Validation from yours truly

window.addEventListener("load", () => {
  const inputLoadElements = document.querySelectorAll(
    '.form__field input[type="text"], .form__field input[type="file"], .form__field input[type="email"], .form__field input[type="tel"], .form__field select, .form__field textarea'
  );

  console.log(inputLoadElements);
  inputLoadElements.forEach((inputElement) => {
    const formFieldElement = inputElement.closest(".form__field");
    const inputValue = inputElement.value.trim();
    const inputType = inputElement.type;
    let isValid = false;

    const formFieldLabel = formFieldElement.querySelector(".form__label");

    // if (inputType === "tel") {
    //   inputElement.setAttribute("pattern", "[0-9]{10}");
    // }

    if (inputValue.length > 0 && inputElement.localName === "input") {
      formFieldElement.classList.add("form__field--valid");
      formFieldLabel.classList.add("form__label--focus");
    } else if (inputValue.length > 0 && inputElement.localName === "select") {
      formFieldElement.classList.add("form__field--valid");
    } else if (inputValue.length > 0 && inputElement.localName == "textarea") {
      formFieldElement.classList.add("form__field--textentered");
    } else {
      formFieldElement.classList.remove("form__field--valid");
    }
  });
});

const inputElements = document.querySelectorAll(
  '.form__field input[type="text"], .form__field input[type="file"], .form__field input[type="email"], .form__field input[type="tel"], .form__field select, .form__field textarea'
);

inputElements.forEach((inputElement) => {
  inputElement.addEventListener("input", function () {
    const formFieldElement = inputElement.closest(".form__field");
    const inputValue = inputElement.value.trim();
    const inputType = inputElement.type;
    let isValid = false;

    if (inputType === "email") {
      isValid = isValidEmail(inputValue);
    } else if (inputType === "tel") {
      //Inputmask({mask: '(999) 999-9999'}).mask(inputElement)
      //$('.phone-us').mask('(000) 000-0000');
      isValid = isValidPhone(inputValue);
    } else if (inputValue.length > 0 && inputElement.localName == "textarea") {
      formFieldElement.classList.add("form__field--textentered");
    } else if (
      inputValue.length === 0 &&
      inputElement.localName == "textarea"
    ) {
      formFieldElement.classList.remove("form__field--textentered");
    } else {
      isValid = inputValue !== "";
    }

    if (isValid) {
      formFieldElement.classList.add("form__field--valid");
    } else {
      formFieldElement.classList.remove("form__field--valid");
    }
  });

  inputElement.addEventListener("focus", function () {
    // console.log("focused");
    const formFieldElement = inputElement.closest(".form__field");

    const formFieldLabel = formFieldElement.querySelector(".form__label");

    formFieldLabel.classList.add("form__label--focus");
  });

  inputElement.addEventListener("blur", function () {
    // console.log("blurred");
    const formFieldElement = inputElement.closest(".form__field");

    const formFieldLabel = formFieldElement.querySelector(".form__label");

    if (inputElement.value == "") {
      formFieldLabel.classList.remove("form__label--focus");
    } else {
    }
  });
});

// Money Mask

const moneyInputs = document.querySelectorAll(".js-shift4");

if (moneyInputs) {
  moneyInputs.forEach((moneyInput) => {
    moneyInput.addEventListener('input', function (e) {
      let value = moneyInput.value.replace(/\D/g, ''); // Remove non-digits
      value = value.replace(/^0+/, ''); // Remove leading zeros

      if (value) {
        value = parseFloat(value / 100).toFixed(2); // Convert to decimal and format
        value = value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'); // Add commas
        moneyInput.value = '$' + value; // Add currency symbol
      } else {
        moneyInput.value = '';
        moneyInput.closest(".form__field").classList.remove("form__field--valid");
      }
    });
  });
}

// End Money Mask

const zipInputs = document.querySelectorAll("input.zip");

zipInputs.forEach((zipInput) => {
  zipInput.addEventListener("input", function () {
    const zipFieldElement = zipInput.closest(".form__field");

    let cleanedInput = this.value.replace(/\D/g, "");

    cleanedInput = cleanedInput.substring(0, 5);

    this.value = cleanedInput;

    if (/^\d{5}(-\d{4})?$/.test(cleanedInput)) {
      zipFieldElement.classList.add("form__field--valid");
    } else {
      zipFieldElement.classList.remove("form__field--valid");
    }
  });
});

function isValidEmail(email) {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^s@]+$/;
  return emailPattern.test(email);
}

const phoneInputs = document.querySelectorAll('input[type="tel"]');

phoneInputs.forEach((phoneInput) => {
  phoneInput.addEventListener("input", function () {
    const telFieldElement = phoneInput.closest(".form__field");

    let cleanedInput = this.value.replace(/\D/g, "");

    cleanedInput = cleanedInput.substring(0, 10);

    this.value = cleanedInput;

    if (/^\d{10}(-\d{4})?$/.test(cleanedInput)) {
      telFieldElement.classList.add("form__field--valid");
    } else {
      telFieldElement.classList.remove("form__field--valid");
    }
    // phoneInput.setAttribute("pattern", "[0-9]{10}");
  });
});

// Multi Select validation shit for connect with an agent bleh
// Get the element, add a click listener...
if (document.querySelector(".js-input--coverage")) {
  window.addEventListener("keyup", function (e) {
    if (
      (e.target && e.target.nodeName == "LI" && e.key === "Enter") ||
      e.keyCode === 13
    ) {
      const multiSelectInputs = document.querySelectorAll(".chosen-choices");

      console.log("List item " + " was key pressed!");

      multiSelectInputs.forEach((multiSelectInput) => {
        if (multiSelectInput.getElementsByClassName("search-choice")[0]) {
          multiSelectInput
            .closest(".form__field")
            .classList.add("form__field--valid");
          multiSelectInput
            .closest(".form__field")
            .querySelector(".form__label")
            .classList.add("form__label--multi-focus");
        } else {
          multiSelectInput
            .closest(".form__field")
            .classList.remove("form__field--valid");
          multiSelectInput
            .closest(".form__field")
            .querySelector(".form__label")
            .classList.remove("form__label--multi-focus");
        }
      });
    }
  });

  window.addEventListener("mouseover", function (e) {
    const multiSelectInputs = document.querySelectorAll(".chosen-choices");
    // e.target is the clicked element!
    // If it was a list item
    if (e.target && e.target.nodeName == "LI") {
      console.log("List item " + " was hovered!");

      console.log(multiSelectInputs);

      multiSelectInputs.forEach((multiSelectInput) => {
        if (multiSelectInput.getElementsByClassName("search-choice")[0]) {
          multiSelectInput
            .closest(".form__field")
            .classList.add("form__field--valid");
          multiSelectInput
            .closest(".form__field")
            .querySelector(".form__label")
            .classList.add("form__label--multi-focus");
        } else {
          multiSelectInput
            .closest(".form__field")
            .classList.remove("form__field--valid");
          multiSelectInput
            .closest(".form__field")
            .querySelector(".form__label")
            .classList.remove("form__label--multi-focus");
        }
      });
    }

    if (e.target && e.target.nodeName == "UL") {
      console.log("UL " + " was hovered!");

      multiSelectInputs.forEach((multiSelectInput) => {
        if (multiSelectInput.getElementsByClassName("search-choice")[0]) {
          multiSelectInput
            .closest(".form__field")
            .classList.add("form__field--valid");
          multiSelectInput
            .closest(".form__field")
            .querySelector(".form__label")
            .classList.add("form__label--multi-focus");
        } else {
          multiSelectInput
            .closest(".form__field")
            .classList.remove("form__field--valid");
          multiSelectInput
            .closest(".form__field")
            .querySelector(".form__label")
            .classList.remove("form__label--multi-focus");
        }
      });
    }
  });
}